export const SEATING_ZONE = {
    america: 'America',
    cambodia: 'Cambodia',
    europe: 'Europe',
    hongkongtaiwan: 'HongKong & Taiwan',
    india: 'India',
    japan: 'Japan',
    korea: 'Korea',
    laos: 'Laos',
    mena: 'MENA',
    philippines: 'Philippines',
    singaporemalaysiabrunei: 'Singapore & Malaysia & Brunei',
    thailand: 'Thailand',
    vietnam: 'Vietnam'
}
